export function rewriteLinksForPreview(html: string): string {
  return html.replace(/<a\b([^>]*)>/gi, (_match, attrs: string) => {
    let next = attrs;
    if (/\btarget\s*=/i.test(next)) {
      next = next.replace(/\btarget\s*=\s*("[^"]*"|'[^']*'|\S+)/i, 'target="_blank"');
    } else {
      next = `${next} target="_blank"`;
    }
    if (/\brel\s*=/i.test(next)) {
      next = next.replace(/\brel\s*=\s*("[^"]*"|'[^']*'|\S+)/i, 'rel="noopener noreferrer"');
    } else {
      next = `${next} rel="noopener noreferrer"`;
    }
    return `<a${next}>`;
  });
}
